import * as Sentry from '@sentry/react';
import { ProjectType } from 'common/types';

export const initSentry = (projectType?: ProjectType) => {
  const {
    VITE_SENTRY_DSN_APP,
    VITE_SENTRY_DSN_FUNNELS,
    VITE_SENTRY_ENVIRONMENT,
    VITE_SENTRY_TRACES_SAMPLE_RATE,
    VITE_SENTRY_REPLAY_SAMPLE_RATE,
    VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE,
  } = import.meta.env;

  const sentryDsn =
    projectType === ProjectType.FUNNELS
      ? (VITE_SENTRY_DSN_FUNNELS as string)
      : (VITE_SENTRY_DSN_APP as string);

  if (!sentryDsn) {
    const projectName = projectType === ProjectType.FUNNELS ? 'funnels' : 'app';
    console.warn(`Sentry DSN not provided for ${projectName}`);
    return;
  }

  Sentry.init({
    dsn: sentryDsn,
    environment: (VITE_SENTRY_ENVIRONMENT as string) || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: VITE_SENTRY_TRACES_SAMPLE_RATE
      ? parseFloat(VITE_SENTRY_TRACES_SAMPLE_RATE as string)
      : 1.0,
    replaysSessionSampleRate: VITE_SENTRY_REPLAY_SAMPLE_RATE
      ? parseFloat(VITE_SENTRY_REPLAY_SAMPLE_RATE as string)
      : 0.1,
    replaysOnErrorSampleRate: VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE
      ? parseFloat(VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE as string)
      : 1.0,
  });
};
